var render = function render(){
  var _vm$statistic, _vm$statistic$employe, _vm$statistic2, _vm$statistic2$employ;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-row', {
    staticClass: "ma-n8",
    attrs: {
      "align": "stretch"
    }
  }, [_c('v-col', {
    staticClass: "pa-8",
    staticStyle: {
      "width": "310px"
    },
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-card', {
    staticClass: "fill-height pa-40",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "gap": "40px"
    },
    attrs: {
      "fill-height": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v(" 참여 회원수 ")]), _c('b', [_vm._v(" " + _vm._s((((_vm$statistic = _vm.statistic) === null || _vm$statistic === void 0 ? void 0 : (_vm$statistic$employe = _vm$statistic.employees) === null || _vm$statistic$employe === void 0 ? void 0 : _vm$statistic$employe.count) || 0).format()) + "명")])]), _c('v-layout', {
    staticStyle: {
      "gap": "8px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('span', [_vm._v(" 참여 기업수 ")]), _c('b', [_vm._v(" " + _vm._s((((_vm$statistic2 = _vm.statistic) === null || _vm$statistic2 === void 0 ? void 0 : (_vm$statistic2$employ = _vm$statistic2.employers) === null || _vm$statistic2$employ === void 0 ? void 0 : _vm$statistic2$employ.count) || 0).format()) + "명")])])], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-8"
  }, [_c('v-card', {
    staticClass: "fill-height pa-40",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "gap": "24px"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-row', {
    staticClass: "ma-n12",
    attrs: {
      "justify": "center"
    }
  }, [_vm._l(_vm.items_chart, function (item) {
    return [_c('v-col', {
      key: item.title,
      staticClass: "pa-12",
      attrs: {
        "lg": "auto"
      }
    }, [_c('statistic-chart', _vm._b({}, 'statistic-chart', item, false))], 1)];
  })], 2), _c('v-row', {
    staticClass: "ma-n4"
  }, [_vm._l(_vm.items_ranks, function (_ref) {
    var title = _ref.title,
      mode = _ref.mode;
    return [_c('v-col', {
      key: title,
      staticClass: "pa-4"
    }, [_c('statistic-ranks', _vm._b({
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var attrs = _ref2.attrs,
            on = _ref2.on;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "outlined": "",
              "block": "",
              "color": "primary"
            }
          }, 'v-btn', attrs, false), on), [_c('span', [_vm._v(" " + _vm._s(title) + " 바로가기 ")])])];
        }
      }], null, true)
    }, 'statistic-ranks', {
      _program: _vm._program,
      title,
      mode
    }, false))], 1)];
  })], 2)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }